import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function inventoryNavigation(
  state = initialState.inventoryNavigation,
  action,
) {
  const { data, type } = action;
  switch (type) {
    case actionTypes.UPDATE_INVENTORY_NAVIGATION: {
      return { ...state, ...data };
    }
    default: {
      return state;
    }
  }
}
